export const MuiCheckbox = (palette) => ({
    root: {
        '&.Mui-focusVisible': {
            outline: 'auto',
            backgroundColor: palette.semantic.colorToggleOffFocus,
        },
        '&:hover': { backgroundColor: palette.semantic.colorToggleOffHover },
        '&:active': { backgroundColor: palette.semantic.colorToggleOffPressed },
        '&.Mui-checked': {
            '&:hover': { backgroundColor: palette.semantic.colorToggleOnHover },
            '&:active': { backgroundColor: palette.semantic.colorToggleOnPressed },
            '&.Mui-focusVisible': { backgroundColor: palette.semantic.colorToggleOnFocus },
        },
        '&.Mui-indeterminate': {
            '&:hover': { backgroundColor: palette.semantic.colorToggleOnHover },
            '&:active': { backgroundColor: palette.semantic.colorToggleOnPressed },
            '&.Mui-focusVisible': { backgroundColor: palette.semantic.colorToggleOnFocus },
        },
    },
});
